import { render, staticRenderFns } from "./simRecoveryRecord.vue?vue&type=template&id=791eda29&scoped=true&"
import script from "./simRecoveryRecord.vue?vue&type=script&lang=js&"
export * from "./simRecoveryRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791eda29",
  null
  
)

export default component.exports